import React, { FC, memo } from 'react';

import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';
import { RouterUtils, useLocation, useNavigate } from 'application/providers/RouterProvider';
import { LocationStatePointsType } from 'application/pages/types';
import { POINTS_MENU_PATH, STREAMS_CATEGORY_PATH } from 'application/consts';

import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';
import IconMapPin from '@zvuk-b2b/react-uikit/ui/icons/MapPin';

import useDeviceBindSuccessModalViewModel from './useDeviceBindSuccessModalViewModel';
import { useOnboardingContext } from '../useOnboardingContext';
import { useOnboardingActionContext } from '../useOnboardingActionContext';
import { TEXTS } from './texts';
import { ModalDescription, SuccessActionButton } from './components';

import styles from './index.module.scss';

const DeviceBindSuccessModal: FC<ModalProps[ModalTypes.DEVICE_BIND_SUCCESS]> = ({ close, replaceModal }) => {
  const { flowType, currentPoint } = useOnboardingContext();
  const { clearCurrentPoint, setFlowType } = useOnboardingActionContext();

  const navigate = useNavigate();
  const location = useLocation<LocationStatePointsType>();

  const { addressHasStream, showWebPlayerButton, onOpenWebPlayerClick, onChangeStreamClick, onClose } =
    useDeviceBindSuccessModalViewModel({
      currentPoint,
      flowType,
      pathname: location.pathname,
      redirectToPointsPage: () => {
        navigate(RouterUtils.generatePath(POINTS_MENU_PATH));
      },
      redirectToStreamsPage: () => {
        navigate(
          RouterUtils.generatePath(STREAMS_CATEGORY_PATH, {
            category: 'recommended',
          }),
          {
            state: { pointsFromLocation: [{ pointId: currentPoint?.id, pointAddress: currentPoint?.address }] },
          }
        );
      },
      close,
      replaceModal,
      clearCurrentPoint,
      setFlowType,
    });

  return (
    <ModalScreen
      title={TEXTS.MODAL_BIND_SUCCESS_TITLE}
      titlePlacement="left"
      containerClassName={styles.container}
      onClose={onClose}
      actionButtons={[
        <SuccessActionButton
          key="button_open_whatever_bind_success_modal"
          showStreamsButton={!addressHasStream}
          showWebPlayerButton={showWebPlayerButton}
          onChangeStreamClick={onChangeStreamClick}
          onOpenWebPlayerClick={onOpenWebPlayerClick}
          onClose={onClose}
        />,
      ]}>
      <ModalDescription
        addressHasStream={addressHasStream}
        isAddressEnabled={currentPoint?.isEnabled === true}
      />

      <div
        key={currentPoint?.id}
        className={styles.address}>
        <IconMapPin className={styles.addressIcon} />
        <span>{currentPoint?.address}</span>
      </div>
    </ModalScreen>
  );
};

export default memo(DeviceBindSuccessModal);
